export const COLORS = {
  SEXY_BLACK: '#14213d',
  SEXY_WHITE: '#fffdf6',
} as const;
